export const periodFormat = (period: string) => {
    switch (period) {
        case '1d':
            return 'day'
        case '7d':
            return 'week'
        case '30d':
            return 'month'
        case '90d':
            return '3 months'
        case '365d':
            return 'year'
        default:
            return period
    }
}